var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"lazy"},[_c('div',{class:_vm.loader},[(_vm.showComp)?_vm._t("default"):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }